<style scoped lang="less"></style>
<template>
  <div>
    <div class="page-content">
      <div class="title">
        <el-row>
          <el-col :span="12">
            最近{{ titleTime
            }}{{ optionData.title ? optionData.title : "" }}数据
          </el-col>
          <el-col :span="12" class="text-right">
            <!-- 刻度1分钟 -->
            <el-button
              type="primary"
              size="small"
              :plain="true"
              @click="timeSlot(optionData.attribute, 0)"
            >最近1个小时</el-button>
            <!-- 刻度5分钟 -->
            <el-button
              type="primary"
              size="small"
              plain
              @click="timeSlot(optionData.attribute, -1)"
            >最近1天</el-button>
            <!-- 刻度1小时 -->
            <el-button
              type="primary"
              size="small"
              plain
              @click="timeSlot(optionData.attribute, -7)"
            >最近1周</el-button>
          </el-col>
        </el-row>
      </div>
      <div class="content">
        <div :id="optionData.attribute" class="echart-main"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "echartsOption",
  props: {
    title: String,
    optionData: Object,
    selectTimeSlot: Function,
    // echartId: {
    //   type: String,
    //   required: true
    // },
    // dateTime: String
  },
  data() {
    return {
      titleTime: "1小时",
      newEchart: "",
      option: {
        tooltip: {
          formatter: function (params) {
            let html = `
                <div class="tooltip-box">
                ${params.name} <br>
                ${params.marker}瞬时流量: ${params.value}
                </div>
            `;
            return html;
          },
        },
        legend: {
          //   data: ["大气压"]
        },
        xAxis: {
          type: "category",
          data: [],
        },
        yAxis: {
          name: "",

          splitLine: {
            show: false, // X轴 网格线 颜色类型的修改
          },
        },
        series: [
          {
            name: "",
            type: "line",
            data: [],
            lineStyle: {
              color: "#6495ed",
              width: 2,
            },
            showAllSymbol: true,
            itemStyle: {
              normal: {
                label: { show: true },
              },
              color: "#6495ed",
            },
          },
        ],
      },
      optionEchart: [],
    };
  },
  methods: {
    getEchartsData() {
      this.pbFunc
        .echartsData(
          this.id,
          this.type,
          this.pbFunc.getDateStr(-5),
          this.pbFunc.getDateStr(1)
        )
        .then((res) => {
          if (res[0]) {
            let echartList = res[1];
            for (let i in echartList) {
              let attributeArr = Object.keys(echartList[i]);
              for (let j in attributeArr) {
                if (attributeArr[j] !== "data_time") {
                  this.optionData[attributeArr[j]].dataY.push(
                    echartList[i][attributeArr[j]]
                  );
                  this.optionData[attributeArr[j]].dataX.push(
                    echartList[i].data_time
                  );
                }
              }
            }
          }
        });
    },
    newEcharts() {
      // console.log("echartId", "sssss");
      this.option.yAxis.name = this.optionData.title + this.optionData.unit; //单位
      this.option.xAxis.data = this.optionData.dataX; //y轴数据
      this.option.series[0].data = this.optionData.dataY; //y轴数据
      this.option.series[0].name = this.optionData.title; //展示数据title
      this.newEchart = this.$Echarts.init(
        document.getElementById(this.optionData.attribute)
      );
      this.newEchart.setOption(this.option);
      // for (let i in this.optionData) {
      //   console.log("i", this.optionData);
      //   this.optionEchart[i] = this.option;
      //   console.log(this.optionEchart[i]);
      //   this.optionEchart[i].yAxis.name =
      //     this.optionData[i].title + this.optionData[i].unit; //单位
      //   this.optionEchart[i].xAxis.data = this.optionData[i].dataX; //y轴数据
      //   this.optionEchart[i].series[0].data = this.optionData[i].dataY; //y轴数据
      //   this.optionEchart[i].series[0].name = this.optionData[i].title; //展示数据title
      //   // setTimeout(() => {
      //   console.log(this.optionData[i].attribute);

      //   let newEchart = this.$Echarts.init(
      //     document.getElementById(this.optionData[i].attribute)
      //   );
      //   newEchart.setOption(this.optionEchart[i]);
      //   // }, 1000);
      // }
    },
    //选择时间段切换数据
    timeSlot(type, number) {
      console.log(type, number);
      let timeSlot = {
        type: type,
        number: number,
      };
      this.$emit("selectTimeSlot", timeSlot, true);
    },
  },
  mounted() {
    setTimeout(() => {
      this.newEcharts();
    }, 1000);
  },
  created() {},
  watch: {
    optionData: {
      handler(newName, oldName) {
        console.log("new1", newName);
        setTimeout(() => {
          this.newEcharts();
        }, 3000);
        // this.newEcharts();
        // this.newEcharts();
        // if (newName) {
        //   this.newEcharts();
        // }
        // if (newName) {
        //   setTimeout(() => {
        //     this.newEcharts();
        //   }, 1000);
        // }
      },
      deep: true,
      // immediate: true
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/echartsOption.vue